(function () {
  'use strict';

  var init = function (section) {
    var list = section.querySelector('.sp-sc-timeline__steps');
    var controls = section.querySelector('[data-sp-timeline-controls]');
    if (!list || !controls) return;

    var cards = Array.prototype.slice.call(
      list.querySelectorAll('.sp-sc-timeline__step')
    );
    var dots = Array.prototype.slice.call(
      controls.querySelectorAll('[data-sp-timeline-dot]')
    );
    var prev = controls.querySelector('[data-sp-timeline-prev]');
    var next = controls.querySelector('[data-sp-timeline-next]');
    if (cards.length < 2 || dots.length !== cards.length) return;

    controls.hidden = false;

    // see the header note about hand-swiping.
    // The scroll position that centres card c in the strip (the cards are centred, not left-aligned).
    var centreLeft = function (c) {
      return c.offsetLeft - list.offsetLeft - (list.clientWidth - c.offsetWidth) / 2;
    };
    var currentIndex = function () {
      var x = list.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var d = Math.abs(centreLeft(cards[i]) - x);
        if (d < bestDist) {
          bestDist = d;
          best = i;
        }
      }
      return best;
    };

    // Strip height follows the card in view, so the gap the comp draws
    // last line rather than from the tallest card in the set. Interpolated
    // across the swipe: at rest it equals one card exactly, and mid-swipe it
    // sits between the two on screen, so neither is ever clipped by the
    // container it is scrolling inside. Reads offsetHeight on the CARDS, not
    // while it constrains that content can only ratchet upward.
    var sizeToView = function () {
      if (cards.length < 2) return;
      // Only the mobile tier makes this strip a horizontal scroller; above it
      // the CSS restores a stacked grid, where an inline height would be
      // wrong. Keyed off the layout itself rather than a breakpoint number,
      // so the two cannot drift apart.
      if (list.scrollWidth <= list.clientWidth) {
        list.style.height = '';
        return;
      }
      var stride = cards[1].offsetLeft - cards[0].offsetLeft;
      if (!stride) return;
      var pos = list.scrollLeft / stride;
      var i = Math.max(0, Math.min(cards.length - 1, Math.floor(pos)));
      var j = Math.min(cards.length - 1, i + 1);
      var f = Math.max(0, Math.min(1, pos - i));
      var h = cards[i].offsetHeight * (1 - f) + cards[j].offsetHeight * f;
      if (h > 0) list.style.height = h.toFixed(1) + 'px';
    };

    var paint = function () {
      sizeToView();
      var i = currentIndex();
      for (var d = 0; d < dots.length; d++) {
        var on = d === i;
        dots[d].classList.toggle('is-active', on);
        dots[d].setAttribute('aria-selected', on ? 'true' : 'false');
      }
      // A disabled control is honest about the ends — the list does not loop.
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === cards.length - 1;
    };

    var go = function (i) {
      var t = Math.max(0, Math.min(cards.length - 1, i));
      var left = Math.max(0, centreLeft(cards[t]));
      if (typeof list.scrollTo === 'function') {
        list.scrollTo({
          left: left,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
            ? 'auto'
            : 'smooth'
        });
      } else {
        list.scrollLeft = left;
      }
    };

    if (prev) prev.addEventListener('click', function () { go(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { go(currentIndex() + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { go(i); });
    });

    var ticking = false;
    list.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        paint();
      });
    }, { passive: true });

    // The card widths change across the mobile tiers, so offsets are re-read
    // rather than cached. The height has to be released BEFORE re-measuring:
    // a card's own offsetHeight is unaffected by the strip's height, but the
    // desktop tier restores a stacked grid where an inline height left over
    // from mobile would be plain wrong.
    window.addEventListener('resize', function () {
      list.style.height = '';
      paint();
    });

    paint();

    // The first paint can land before the strip is laid out as a scroller —
    // and correctly declined to set a height, leaving slide 1 at the tallest
    // card until the first scroll. Webfonts also re-wrap the bodies after
    // that point, which changes the very heights this reads. So re-run on
    // `load`, and keep watching the cards' own size rather than assuming one
    // late call is enough.
    window.addEventListener('load', paint);
    if (typeof ResizeObserver === 'function') {
      var ro = new ResizeObserver(function () { paint(); });
      for (var c = 0; c < cards.length; c++) ro.observe(cards[c]);
    }
  };

  var boot = function () {
    var sections = document.querySelectorAll('.sp-sc-timeline');
    for (var i = 0; i < sections.length; i++) init(sections[i]);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme-editor reload: Shopify re-renders the section without a page load.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('.sp-sc-timeline')) boot();
  });
})();
